// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e770f160","252":"8f0562b1","318":"52a16631","419":"cb54285d","480":"9f875990","563":"00b4db7e","774":"aa0adc6b","883":"36034a52","942":"d6db03ca"}[chunkId] + ".chunk.js";
};